import type { Cart } from "@packages/sdk";

import { CartTotal } from "./CartTotal";
import { OrderSummary } from "./OrderSummary";

type CartInfoProps = {
  cart: Cart;
  onPromoCodeSubmit: (newCode: string) => void | Promise<void>;
};

export const CartInfo = ({ cart, onPromoCodeSubmit }: CartInfoProps) => {
  return (
    <>
      <CartTotal {...cart} />
      <OrderSummary onPromoCodeSubmit={onPromoCodeSubmit} cart={cart} />
    </>
  );
};
